var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeIconMinimizeSign60573652(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5614 11.6984L2.32469 1.4617C1.79356 0.930567 1.059 0.80399 0.68401 1.17898L0.678981 1.18401C0.30399 1.559 0.430567 2.29356 0.961698 2.82469L11.1984 13.0614C11.7296 13.5926 12.4641 13.7191 12.8391 13.3441L12.8441 13.3391C13.2191 12.9641 13.0926 12.2296 12.5614 11.6984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.961716 11.6984L11.1985 1.4617C11.7296 0.930567 12.4641 0.80399 12.8391 1.17898L12.8442 1.18401C13.2192 1.559 13.0926 2.29356 12.5614 2.82469L2.32471 13.0614C1.79358 13.5926 1.05902 13.7191 0.684028 13.3441L0.678999 13.3391C0.304008 12.9641 0.430585 12.2296 0.961716 11.6984Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeIconMinimizeSign60573652);
export default __webpack_public_path__ + "static/media/free-icon-minimize-sign-6057365 2.c795d5a066317fffed0c7f05147c8fb2.svg";
export { ForwardRef as ReactComponent };